/**
 * Translations offered in Vox Viva navigation and Bible search.
 * Add canonical IDs here only once permission to offer that edition is confirmed.
 * Keep this separate from the generated server catalogue: refreshing metadata must
 * not enable new translations. Authored references and previews are unaffected.
 */
export const navigationTranslationIds: readonly string[] = [
  "afr1953",
  "esv2001",
  "hcsb2004",
  "kjv1611",
  "nasb1995",
  "nbg1951",
  "neg1979",
  "sg21",
  "sblg2010",
  "sv1750",
  "wlc1982",
];
